import { useState } from 'react';
import clsx from 'clsx';

interface Hit {
  partyName: string;
  hits: { listTargetName: string; reason: string; listKind: string }[];
}

interface Props {
  summary?: string | null;  // JSON string from API
  className?: string;
}

function parseSummary(raw?: string | null): Hit[] {
  if (!raw) return [];
  try {
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function BlacklistAlertBadge({ summary, className }: Props) {
  const [show, setShow] = useState(false);
  const hits = parseSummary(summary);
  const names = hits.map(h => h.partyName).join(', ') || 'unknown entity';

  return (
    <div className={clsx('relative inline-flex items-center gap-1', className)}>
      <button
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        onClick={() => setShow(s => !s)}
        className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-sm bg-negative/10 border border-negative/30 text-negative text-xs font-medium"
        title="Blacklist hit"
      >
        <span className="h-1.5 w-1.5 rounded-full bg-negative inline-block" />
        blacklist hit
      </button>

      {show && hits.length > 0 && (
        <div className="absolute top-full left-0 mt-1 w-72 bg-bg hairline rounded-sm z-50 p-2 shadow-sm text-xs">
          {hits.map((h, i) => (
            <div key={i} className={clsx(i > 0 && 'mt-2 pt-2 hairline-t')}>
              <div className="font-medium text-negative">{h.partyName}</div>
              {h.hits.map((hit, j) => (
                <div key={j} className="mt-0.5 text-muted">
                  matched &ldquo;{hit.listTargetName}&rdquo; &mdash; {hit.reason}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
